import deepmerge from 'deepmerge'
import qs from 'qs'

export default {
  clear (state) {
    state.logs = []
  },

  request (state, config) {
    // 登録する添字を得る
    config.traceID = state.logs.length

    // headers を整理する
    const headers = deepmerge(config.headers.common, config.headers[config.method])
    for (const key in config.headers) {
      switch (key) {
        case 'common':
        case 'delete':
        case 'get':
        case 'head':
        case 'post':
        case 'put':
        case 'patch':
          break
        default:
          headers[key] = config.headers[key]
      }
    }

    // query を整理する
    let query = []
    const q = qs.stringify(config.params, { arrayFormat: 'brackets' })
    if (q) {
      query = q.split('&')
    }
    query = query.map(q => decodeURIComponent(q))

    // リクエストを登録する
    state.logs.push({
      start: Date.now(),
      end: undefined,

      req: {
        url: `${config.baseURL.slice(0, -1)}${config.url}`,
        method: config.method,
        headers: headers,
        query: query,
        data: config.data
      },

      res: {
        status: 0,
        statusText: '',
        headers: {},
        data: undefined
      }
    })
  },

  response (state, response) {
    // ログ要素を取得する
    const log = state.logs[response.config.traceID]

    // 終了時刻を書き込む
    log.end = Date.now()

    // レスポンスの内容を書き込む
    log.res.status = response.status
    log.res.statusText = response.statusText
    log.res.headers = response.headers
    log.res.data = response.data
  }
}
